function createAbortError() {
  const error = new Error('Request was cancelled.')
  error.code = 'ERR_CANCELED'
  return error
}

export function sleep(ms, signal) {
  if (signal?.aborted) return Promise.reject(createAbortError())
  return new Promise((resolve, reject) => {
    let timeout
    const cleanup = () => signal?.removeEventListener('abort', onAbort)
    const onAbort = () => {
      globalThis.clearTimeout(timeout)
      reject(createAbortError())
    }
    timeout = globalThis.setTimeout(() => {
      cleanup()
      resolve()
    }, ms)
    signal?.addEventListener('abort', onAbort, { once: true })
  })
}
